import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import { getAxiosConfig } from "../../../utils/helpers";
import TableView from "./TableView";
import MoodboardView from "./MoodboardView";
import { Button, Textarea } from "@chakra-ui/react";
import SelectCompanyLogo from "../admin/Presentation/Components/SelectCompanyLogo";
import PopupWrapper from "../../../components/PopupWrapper";
import { toast } from "react-toastify";
import { set } from "react-hook-form";
const MaterialMain = () => {
  const nav = useNavigate();
  const [view, setView] = useState("Table");
  const { projectData, basicInfo } = useOutletContext();
  const [materialData, setMaterialData] = useState({});
  const [showPublicLinkPopup, setShowPublicLinkPopup] = useState(false);
  const [copySuccess, setCopySuccess] = useState(false);
  const [isEditPublicView, setIsEditPublicView] = useState(false);
  // console.log("projectData", projectData);
  const [metaData, setMetaData] = useState({
    _id: null,
    companyLogo: [],
    metaData: {},
  });
  const projectId = projectData?._id;
  const [isMetaPopupOpen, setIsMetaPopupOpen] = useState(false);

  let data = {};
  Object.entries(materialData).forEach(([key, value]) => {
    data[key] = value?.map((v) => v?.images).flat();
  });
  console.log({ materialData, data });

  //   const fetchProjectImgs = async () => {
  //   try {
  //     const response = await axios.get(
  //       `${process.env.REACT_APP_BACK_URL}/api/project-showcases/images/${projectId}`,
  //     );
  //     // setImgs(response.data);
  //     console.log({ res: response.data });
  //     const materialsData = (response.data?.projectImageMaterials || []).find(
  //       (v) => v.image == selectedProjectImage,
  //     )?.materials;
  //     let selectedMaterial = {};
  //     materialsData?.forEach((m) => {
  //       if (selectedMaterial[m.zone]) {
  //         selectedMaterial[m.zone].push({
  //           materialId: m.materialId?._id || m?.materialId,
  //           material: m?.materialId,
  //           section: m.section,
  //         });
  //       } else {
  //         selectedMaterial[m.zone] = [
  //           {
  //             materialId: m.materialId?._id || m?.materialId,
  //             material: m?.materialId,
  //             section: m.section,
  //           },
  //         ];
  //       }
  //     });
  //     SetDesignDataForExistingMaterials(
  //       projectId,
  //       response.data?.project?.title || "test-name",
  //       selectedMaterial,
  //     );
  //     window.scrollTo(0, 0); // Scroll to top on project load
  //   } catch (error) {
  //     console.error("Failed to fetch project data", error);
  //   }
  // };

  async function fetchProjectMaterials() {
    try {
      // const {
      //   data: { data },
      // } = await axios.get(
      //   `${process.env.REACT_APP_BACK_URL}/api/material/get-project/${projectData?._id}`,
      //   getAxiosConfig(),
      // );
      const response = await axios.get(
        `${process.env.REACT_APP_BACK_URL}/api/project-showcases/images/${projectData?._id}`,
        getAxiosConfig(),
      );
      // console.log("Project Materials", data);
      // setMaterialData(project?.[0]?.materialData)
      console.log({ data: response?.data?.projectImageMaterials });
      let obj = {};
      response?.data?.projectImageMaterials?.forEach((item) => {
        item?.materials?.forEach((material) => {
          if (obj[material?.zone]) {
            obj[material?.zone].push({
              ...material?.materialId,
            });
          } else {
            obj[material?.zone] = [
              {
                ...material?.materialId,
              },
            ];
          }
        });
      });
      // data?.materials?.forEach((item) => {
      //   item?.projects?.[0]?.zones?.forEach((zone) => {
      //     if (!obj[zone]) {
      //       obj[zone] = [item];
      //     } else {
      //       obj[zone].push(item);
      //     }
      //   });
      // });

      setMaterialData(obj);
    } catch (error) {
      console.log("ERROR in material", error?.message);
    }
  }
  const fetchMetaData = async () => {
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACK_URL}/api/material/project-meta/${projectData?._id}`,
        getAxiosConfig(),
      );
      console.log("Meta Data", data);

      if (data?.data) {
        if (Array.isArray(data?.data)) {
          setMetaData({
            companyLogo: data?.data?.[0]?.companyLogo,
            metaData: data?.data?.[0]?.metaData,
            _id: data?.data?.[0]?._id,
          });
        } else
          setMetaData({
            companyLogo: data?.data?.companyLogo,
            metaData: data?.data?.metaData,
            _id: data?.data?._id,
          });
      }
    } catch (error) {
      console.log(error?.message);
    }
  };
  async function handleAddMetaData() {
    try {
      let formdata = new FormData();
      if (metaData?.companyLogo?.[0] instanceof File) {
        formdata.append("companyLogo", metaData?.companyLogo?.[0]);
      }
      formdata.append("projectId", projectId);
      formdata.append("metaData", JSON.stringify(metaData?.metaData));
      console.log(metaData, formdata);
      if (metaData?._id) {
        const { data } = await axios.put(
          `${process.env.REACT_APP_BACK_URL}/api/material/materials-meta/${metaData?._id}`,
          formdata,
          getAxiosConfig({}, true),
        );
        console.log("PUT", data);
        toast.success("Meta Data Updated Successfully");
        setMetaData({
          companyLogo: data?.data?.companyLogo,
          metaData: data?.data?.metaData,
          _id: data?.data?._id,
        });
      } else {
        const { data } = await axios.post(
          `${process.env.REACT_APP_BACK_URL}/api/material/materials-meta`,
          formdata,
          getAxiosConfig({}, true),
        );

        console.log("POST", data);
        toast.success("Meta Data Added Successfully");
        setMetaData({
          companyLogo: data?.data?.companyLogo,
          metaData: data?.data?.metaData,
          _id: data?.data?._id,
        });
      }

      setIsMetaPopupOpen(false);
    } catch (error) {
      console.log(error?.message);
      toast.error("Error in adding meta data");
    }
  }

  useEffect(() => {
    if (projectData?._id) {
      fetchProjectMaterials();
      fetchMetaData();
    }
  }, [projectData]);
  // console.log("ASDF", projectData);

  const publicViewUrl = `${window.location.origin}/${isEditPublicView ? "edit-public-view" : "public-view"}/${projectData?.title}/${projectData?._id}`;

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(publicViewUrl);
      setCopySuccess(true);
      setTimeout(() => setCopySuccess(false), 2000);
    } catch (err) {
      console.error("Failed to copy: ", err);
    }
  };

  const handlePublicViewClick = (isEdit) => {
    console.log("Material Data", isEditPublicView, isEdit);
    setShowPublicLinkPopup(true);
    if (isEdit) {
      setIsEditPublicView(true);
    }
  };
  // console.log(metaData);
  return (
    <>
      <div className="container mx-auto px-4 ">
        <div className="flex justify-end gap-4">
          <Button
            colorScheme="teal"
            variant={"outline"}
            onClick={() => setIsMetaPopupOpen(true)}
          >
            Edit Meta Data
          </Button>
          <Button
            colorScheme="green"
            variant={"solid"}
            onClick={() =>
              nav(
                `/edit-public-view/${projectData?.title}/` + projectData?._id,
                {
                  state: { data },
                },
              )
            }
          >
            Edit Public View
          </Button>
          <Button
            colorScheme="teal"
            onClick={() => handlePublicViewClick(false)}
          >
            Public View
          </Button>
          <div className="flex gap-2 px-2 py-1.5 bg-teal-100 rounded-lg items-center ">
            {["Moodboard", "Table"].map((curr, idx) => (
              <div
                className={
                  curr == view
                    ? "bg-teal-500 px-1 py-1 rounded-lg text-white text-sm cursor-pointer"
                    : "text-gray-500 text-sm cursor-pointer"
                }
                onClick={() => setView(curr)}
                key={idx}
              >
                {curr}
              </div>
            ))}
          </div>
        </div>
        <div>
          {view === "Table" ? (
            <TableView
              materialData={materialData}
              projectId={projectData?._id}
            />
          ) : (
            <MoodboardView data={data} />
          )}
        </div>

        {/* Public Link Popup */}
        {showPublicLinkPopup && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm">
            <div className="bg-white rounded-2xl shadow-2xl border border-gray-200 w-full max-w-lg mx-4 overflow-hidden">
              {/* Header */}
              <div className="bg-gradient-to-r from-teal-500 to-teal-600 px-6 py-4">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-3">
                    <div className="w-8 h-8 bg-white bg-opacity-20 rounded-full flex items-center justify-center">
                      <svg
                        className="w-5 h-5 text-white"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"
                        />
                      </svg>
                    </div>
                    <h3 className="text-xl font-semibold text-white">
                      Public View Link
                    </h3>
                  </div>
                  <button
                    onClick={() => setShowPublicLinkPopup(false)}
                    className="text-white hover:bg-white hover:bg-opacity-20 p-1 rounded-full transition-colors"
                  >
                    <svg
                      className="w-5 h-5"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                </div>
              </div>

              {/* Content */}
              <div className="px-6 py-6">
                <div className="mb-6">
                  <h4 className="text-lg font-semibold text-gray-800 mb-2">
                    Share Project
                  </h4>
                  <p className="text-gray-600 text-sm mb-4">
                    Share this public link to allow others to view your project
                    without signing in.
                  </p>

                  {/* URL Display and Copy */}
                  <div className="flex items-center gap-2 p-3 bg-gray-50 border border-gray-200 rounded-lg">
                    <input
                      type="text"
                      value={publicViewUrl}
                      readOnly
                      className="flex-1 bg-transparent text-sm text-gray-700 outline-none"
                    />
                    <button
                      onClick={handleCopyLink}
                      className={`flex items-center gap-2 px-3 py-2 rounded-lg font-medium text-sm transition-all duration-200 ${
                        copySuccess
                          ? "bg-green-100 text-green-600"
                          : "bg-teal-100 text-teal-600 hover:bg-teal-200"
                      }`}
                    >
                      {copySuccess ? (
                        <>
                          <svg
                            className="w-4 h-4"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M5 13l4 4L19 7"
                            />
                          </svg>
                          Copied!
                        </>
                      ) : (
                        <>
                          <svg
                            className="w-4 h-4"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
                            />
                          </svg>
                          Copy
                        </>
                      )}
                    </button>
                  </div>
                </div>

                {/* Action Buttons */}
                <div className="flex gap-3">
                  <button
                    onClick={() => {
                      setShowPublicLinkPopup(false);
                      setIsEditPublicView(false);
                    }}
                    className="flex-1 bg-gray-100 hover:bg-gray-200 text-gray-700 font-semibold py-3 px-4 rounded-xl transition-all duration-200 flex items-center justify-center gap-2"
                  >
                    Close
                  </button>
                  <button
                    onClick={() => {
                      setShowPublicLinkPopup(false);
                      setIsEditPublicView(false);
                      nav(
                        `/${isEditPublicView ? "edit-public-view" : "public-view"}/${projectData?.title?.replaceAll("/", "_")}/` +
                          projectData?._id,
                        {
                          state: { data },
                        },
                      );
                    }}
                    className="flex-1 bg-gradient-to-r from-teal-500 to-teal-600 hover:from-teal-600 hover:to-teal-700 text-white font-semibold py-3 px-4 rounded-xl transition-all duration-200 transform hover:scale-105 shadow-lg hover:shadow-xl flex items-center justify-center gap-2"
                  >
                    <svg
                      className="w-4 h-4"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                      />
                    </svg>
                    Open Public View
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      {isMetaPopupOpen && (
        <PopupWrapper
          heading={"Add Meta Data"}
          onClose={() => setIsMetaPopupOpen(false)}
          width={"max-w-4xl"}
          handleSubmit={handleAddMetaData}
          isShowAction={true}
        >
          <div className="pt-2 space-y-4">
            <SelectCompanyLogo
              image={basicInfo?.companyLogo?.[0] || ""}
              isViewOnly
              setImage={(image) =>
                setMetaData((prev) => ({ ...prev, companyLogo: [image] }))
              }
            />
            <div className="grid grid-cols-2 gap-4 max-h-[60vh] overflow-y-auto">
              {Object.keys(materialData).map((v) => (
                <div className="bg-gray-100 rounded-lg p-2 space-y-1 ">
                  <h2 className="">{v} description</h2>
                  <Textarea
                    placeholder={`Enter ${v} description here`}
                    value={metaData?.metaData?.[v] || ""}
                    onChange={(e) =>
                      setMetaData((prev) => ({
                        ...prev,
                        metaData: { ...prev.metaData, [v]: e.target.value },
                      }))
                    }
                  />
                </div>
              ))}
            </div>
          </div>
        </PopupWrapper>
      )}
    </>
  );
};

export default MaterialMain;
